<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <div id="app" class="my-0 py-0">
            <v-app id="inspire">
                <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                    <v-card v-model="show">
                        <v-toolbar dark color="blue">
                            <v-toolbar-title class="my-0 py-0">Cargar Datos: </v-toolbar-title>
                            <v-spacer></v-spacer>
                            {{ codgral }} - {{ descr }}
                            <v-spacer></v-spacer>
                            Año: {{ anio }}
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click="show = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                    </v-card>
                    <v-card color="blue lighten-4">
                        <v-card-text>
                            <v-row dense v-if="periodo == 'M'">
                                <v-col cols="6" sm="6" md="2">
                                    <v-text-field label="Enero" dense v-model="mes[0].valor">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    <v-text-field label="Febrero" dense v-model="mes[1].valor">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    <v-text-field label="Marzo" dense v-model="mes[2].valor">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    <v-text-field label="Abril" dense v-model="mes[3].valor">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    <v-text-field label="Mayo" dense v-model="mes[4].valor">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    <v-text-field label="Junio" dense v-model="mes[5].valor">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row dense v-if="periodo == 'M'">
                                <v-col cols="6" sm="6" md="2">
                                    <v-text-field label="Julio" dense v-model="mes[6].valor">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    <v-text-field label="Agosto" dense v-model="mes[7].valor">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    <v-text-field label="Septiembre" dense v-model="mes[8].valor">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    <v-text-field label="Octubre" dense v-model="mes[9].valor">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    <v-text-field label="Noviembre" dense v-model="mes[10].valor">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    <v-text-field label="Diciembre" dense v-model="mes[11].valor">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row dense v-if="periodo == 'S'">
                                <v-col cols="6" sm="6" md="2">
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    <v-text-field label="1° semestre" dense v-model="s1">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    <v-text-field label="2° semestre" dense v-model="s2">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                </v-col>
                            </v-row>
                            <v-row dense v-if="periodo == 'A'">
                                <v-col cols="6" sm="6" md="2">
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    <v-text-field label="Anual" dense v-model="anual">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="12" md="12">
                                    <v-textarea label="Observaciones" dense rows="2" auto-grow v-model="observ">
                                    </v-textarea>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="6" sm="6" md="3">
                                    <v-select dense v-model="estado" :items="estados" label="Estado" item-text="detalle"
                                        item-value="valor"></v-select>
                                </v-col>
                                <v-col cols="6" sm="6" md="3">
                                    <v-text-field label="Fecha" dense v-model="fecha">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card color="blue" dark tile>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="success" @click.stop="guardar" :disabled="deshabilitar">Guardar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-app>
        </div>
    </v-dialog>
</template>

<script>
import { forEach } from "lodash";
import axios from "../../axios-auth.js";
import moment from "moment";
export default {
    data: (vm) => ({
        lazy: false,
        valid: false,
        enero: "",
        febrero: "",
        marzo: "",
        abril: "",
        mayo: "",
        junio: "",
        julio: "",
        agosto: "",
        septiembre: "",
        octubre: "",
        noviembre: "",
        diciembre: "",
        s1: "",
        s2: "",
        anual: "",
        fecha: "",
        estado: "",
        observ: "",
        listado: [],
        mes: [{ valor: "" },
        { valor: "" },
        { valor: "" },
        { valor: "" },
        { valor: "" },
        { valor: "" },
        { valor: "" },
        { valor: "" },
        { valor: "" },
        { valor: "" },
        { valor: "" },
        { valor: "" },
        ],
        deshabilitar: false,
        estados: [{ detalle: "Provisorio", valor: "P" },
        { detalle: "Definitivo", valor: "D" },
        ],

    }),
    props: ["visible", "codgral", "periodo", "anio", "descr"],
    computed: {
        show: {
            get() {
                if (this.visible == true) {
                    this.cargardatos();
                }
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$emit("close");
                }
            },
        },
    },
    methods: {

        cargardatos() {
            let self = this;
            axios
                .get("/Indicadores/Cargardatos?", {
                    params: {
                        codgral: self.codgral,
                        anio: self.anio,
                    },
                })
                .then((response) => {
                    if (self.periodo == "S") {
                        self.s1 = response.data[0].valor;
                        self.s2 = response.data[1].valor;
                    }
                    if (self.periodo == "A") {
                        self.anual = response.data[0].valor;
                    }
                    if (self.periodo == "M") {
                        response.data.forEach((element) => {
                            self.mes[element.periodo - 1].valor = element.valor;
                        })
                    }
                    self.estado = response.data[0].estado;
                    self.observ = response.data[0].observ;
                    self.fecha = response.data[0].fecha;

                })
                .catch((error) => {
                    console.log(error);
                });
        },
        guardar() {
            this.$swal({
                title: "Guardar Dato indicadores",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    this.deshabilitar = true;
                    var i = 0;
                    if (this.periodo == "S") {
                        if (this.s1 != "" && this.s1 != null) {
                            this.listado.push({
                                codgral: this.codgral,
                                periodo: "1",
                                anio: this.anio,
                                valor: this.s1,
                                fecha: this.fecha,
                                observ: this.observ,
                                estado: this.estado,
                            })
                        }
                        if (this.s2 != "" && this.s2 != null) {
                            this.listado.push({
                                codgral: this.codgral,
                                periodo: "2",
                                anio: this.anio,
                                valor: this.s2,
                                fecha: this.fecha,
                                observ: this.observ,
                                estado: this.estado,
                            })
                        }
                    }
                    if (this.periodo == "A") {
                        if (this.anual != "" && this.anual != null) {
                            this.listado.push({
                                codgral: this.codgral,
                                periodo: "1",
                                anio: this.anio,
                                valor: this.anual,
                                fecha: this.fecha,
                                observ: this.observ,
                                estado: this.estado,
                            })
                        }
                    }
                    if (this.periodo == "M") {
                        this.mes.forEach((element) => {
                            i = i + 1;
                            if (element.valor != "" && element.valor != null) {
                                this.listado.push({
                                    codgral: this.codgral,
                                    periodo: i,
                                    anio: this.anio,
                                    valor: element.valor,
                                    fecha: this.fecha,
                                    observ: this.observ,
                                    estado: this.estado,
                                })
                            }
                        })
                    }
                    let self = this;
                    console.log("LISTADO ", self.listado)
                    axios
                        .post("/Indicadores/GuardarDatos", self.listado)
                        .then((response) => {
                            self.$refs.form.resetValidation();

                            self.showAlert({
                                icon: "success",
                                title: "Dato guardado con éxito",
                                vm: self,
                            });
                            self.vaciarModels();
                            self.$emit("close");
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                }
            });
        },
        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 2000,
            });
        },
        vaciarModels() {

            this.estado = "";
            this.listado = [];
            this.fecha = "";
            this.observ = "";
            this.s1 = "";
            this.s2 = "";
            this.anual = "";
            this.mes = [{ valor: "" },
            { valor: "" },
            { valor: "" },
            { valor: "" },
            { valor: "" },
            { valor: "" },
            { valor: "" },
            { valor: "" },
            { valor: "" },
            { valor: "" },
            { valor: "" },
            { valor: "" },
            ];
            this.deshabilitar = false;
        },
    },
}
</script>